import { render } from "./GemMechanism01.vue?vue&type=template&id=456e40aa&scoped=true"
const script = {}

import "./GemMechanism01.vue?vue&type=style&index=0&id=456e40aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456e40aa"]])

export default __exports__